import React from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';

import { FormProps } from './interface';

export const Form = (props: FormProps) => {
  const {
    children,
    context,
    criteriaMode,
    defaultValues,
    delayError,
    errors,
    handleSubmit,
    mode,
    reValidateMode,
    resetOptions,
    resolver,
    schema,
    shouldFocusError,
    shouldUnregister,
    shouldUseNativeValidation,
    values,
  } = props;

  const methods = useForm({
    context,
    criteriaMode,
    defaultValues,
    delayError,
    errors,
    mode,
    reValidateMode,
    resetOptions,
    resolver: resolver ? resolver(schema) : yupResolver(schema),
    shouldFocusError,
    shouldUnregister,
    shouldUseNativeValidation,
    values,
  });

  const onSubmit: SubmitHandler<typeof schema> = (data) => handleSubmit(data);

  return (
    /* "handleSubmit" will validate your inputs before invoking "onSubmit" */
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>{children}</form>
    </FormProvider>
  );
};
